import React, { useCallback, useMemo } from "react";
import * as S from "../OverviewHero.styles";
import { ProgressAnimationButton } from "components/ProgressAnimationButton";
import { IOverviewHeroSlide } from "../OverviewHero.types";
import { useTranslation } from "hooks/useTranslation";

export const OverviewTabs = ({
  slides,
  activeTab,
  videoPlaybackTime,
  isInView,
  onUpdateTab,
}: Readonly<{
  slides: Array<IOverviewHeroSlide>;
  activeTab: IOverviewHeroSlide;
  videoPlaybackTime: Record<string | number, number>;
  isInView?: boolean;
  onUpdateTab?: (tab: IOverviewHeroSlide) => void;
}>) => {
  const { t } = useTranslation();

  const playbackTime = useMemo(() => {
    return videoPlaybackTime[activeTab.id];
  }, [activeTab.id, videoPlaybackTime]);

  const isActive = useCallback(
    (tab: IOverviewHeroSlide) => {
      return isInView && tab.id === activeTab.id && !!playbackTime;
    },
    [isInView, activeTab.id, playbackTime],
  );

  return (
    <S.Content>
      <S.TabScrollContainer
        direction="horizontal"
        align="center"
        scrollStepType="itemWidth"
        alignActive="center"
        hideArrows
        enableWheelScroll
        $itemsCount={slides?.length}
        gap={8}
        activeIndex={activeTab?.index}
        items={slides.map((tab) => ({
          id: String(tab.id),
          key: tab.id,
          render: () => (
            <S.ButtonWrapper>
              <ProgressAnimationButton
                isActive={tab.id === activeTab.id}
                canPlayAnimation={isActive(tab)}
                variant="secondary"
                text={t(tab.label)}
                playbackTimeInSeconds={
                  playbackTime || tab.playbackTimeInSeconds
                }
                handleClick={() => onUpdateTab(tab)}
              />
            </S.ButtonWrapper>
          ),
        }))}
      />
    </S.Content>
  );
};
